import { Stack } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { TableParagraph } from 'theme/elements/Paragraphs';
import { ServerPaginatedTable } from 'components/table';
import * as TableConfig from './tablesConfig';
import {
	digitalBalanceRequestsTableTypes,
	DOCUMENTED_COLUMNS,
	DIGITAL_BALANCE_SORTABLE_COLUMNS,
} from './tables.types';
import { selectTranslations } from 'state/reducers/translation.reducers';
import React from 'react';
import { getCompanies } from 'state/reducers/global.reducer';
import { Order } from 'components/table/types';
import { DEFAULT_PAGE_SIZE } from 'constants/pagination.constants';

type Props = {
	requests: { data: any[]; pagination: { total: number; hasMore: boolean } };
	page: number;
	isLoading: boolean;
	onPageChange: (page: number) => void;
	onSortChange: (sortBy: string, sortOrder: Order) => Promise<void> | void;
};

export const DigitalBalanceRequestsTables: React.FC<Props> = ({
	requests,
	page,
	isLoading,
	onPageChange,
	onSortChange,
}) => {
	const companies = useAppSelector(getCompanies);
	const t = useAppSelector(selectTranslations);

	return (
		<Stack spacing={2}>
			<TableParagraph
				title={t('page.digitalBalanceRequests.table.documented.title')}
				text={requests.pagination.total + ' ' + t('messages.requests')}
			/>
			<ServerPaginatedTable
				defaultSortBy="createdAt"
				defaultOrderBy="desc"
				data={TableConfig.tableData(
					digitalBalanceRequestsTableTypes.DIGITAL_BALANCE_REQUESTS,
					Array.isArray(requests.data) ? requests.data : [],
					t,
					companies
				)}
				columns={TableConfig.buildColumns(
					digitalBalanceRequestsTableTypes.DIGITAL_BALANCE_REQUESTS,
					t,
					undefined,
					DOCUMENTED_COLUMNS,
					DIGITAL_BALANCE_SORTABLE_COLUMNS
				)}
				perPage={DEFAULT_PAGE_SIZE}
				serverPagination={{
					total: requests.pagination.total,
					hasMore: requests.pagination.hasMore,
					currentPage: page,
					onPageChange,
					onSortChange,
					isLoading,
				}}
			/>
		</Stack>
	);
};
